<template>
  <div id="Allbtn" v-if="routeList">
    <!-- 考试的求助 -->
    <div v-if="showHelp" class="faceTipBox cursor">
      <faceTipBox1></faceTipBox1>
    </div>
    <!-- 咨询 -->
    <!--<div v-if="!showHelp" class="advisory cursor"  @click="toggleServiceDialog">-->
    <!--  &lt;!&ndash;<img :src="$t('flowImage12')" alt="" class="erCode2" v-if="showCode">&ndash;&gt;-->
    <!--  <div id="h5lxwm" class="ContactUs"></div>-->
    <!--  &lt;!&ndash;<img src="" alt="" v-if="$i18n.locale === 'en' " class="ContactUs">&ndash;&gt;-->
    <!--  &lt;!&ndash;<img :src="$i18n.locale == 'en' ? 'https://img.webloom.cn/Img/kefulogoEn.gif?t='+ t : 'https://img.webloom.cn/Img/kefulogoCn.gif?t=' + t" alt="" class="ContactUs">&ndash;&gt;-->
    <!--</div>-->
    <div class="kefuBox cursor" v-if="!showHelp" @click="toggleServiceDialog">
      <img :class="$i18n.locale === 'en' ? 'kefuImgen' : 'kefuImgcn'" :src="$i18n.locale === 'en'  ? 'https://img.webloom.cn/Img/KFen.png' : 'https://img.webloom.cn/Img/KFcn.png'" alt="">
      <!--<img class="kefuImg" src="https://img.webloom.cn/Img/KFen.png" alt="">-->
    </div>
    <!-- 右下角公告铃铛 + 气泡：暂时关闭
    <div class="btnNew cursor" @mouseover="infoMouseover" @mouseout="infoMouseout" v-if="showNoticeBell" >
      <img src="https://img.webloom.cn/Img/lingdang.png" alt="" class="btnIcon lingdangIcon">
      <div class="info" v-if="showNoticeBell">
        <transition name="fade">
          <div class="no_info" v-if="infoDialog && (noticeNo === 0)">
            <div class="no_info_title">{{$t('flowFollowUs1')}}</div>
            <div class="no_info_text">
              <span class="cursor" @click="toNotice">{{$t('flowFollowUs2')}}</span>
            </div>
          </div>
          <div class="yes_info" v-else-if="infoDialog">
            <div class="yes_info_top">{{$t('flowFollowUs3')}}</div>
            <div class="yes_info_li cursor"
                 @click="toInfo(item)"
                 v-for="item in noticeList"
                 :key="item.noticeId">
              <div class="yes_info_li_title">
                {{item.noticeTitle}}
              </div>
              <div class="yes_info_li_time">
                {{item[$t('flowMessage39')] ? item[$t('flowMessage39')] : item.publishTimeStr}}
              </div>
            </div>
            <div class="yes_info_bottom">
              <span class="cursor" @click="toNotice">{{$t('flowFollowUs4')}}</span>
            </div>
          </div>
        </transition>
      </div>
    </div>
    -->
    <!--<div class="top btn_box" @mouseover="infoMouseover" @mouseout="infoMouseout" v-if="$route.meta.Allbtn_info && !showHelp " >-->
    <!--  &lt;!&ndash; 消息 &ndash;&gt;-->
    <!--  <div class="info" v-if="$route.meta.Allbtn_info">-->
    <!--    &lt;!&ndash;        <div class="info_new" v-if="noticeNo != 0">&ndash;&gt;-->
    <!--    &lt;!&ndash;          NEW&ndash;&gt;-->
    <!--    &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--    <transition name="fade">-->
    <!--      &lt;!&ndash; 没有未读的公告 &ndash;&gt;-->
    <!--      <div class="no_info" v-if="infoDialog && (noticeNo === 0)">-->
    <!--        <div class="no_info_title">{{$t('flowFollowUs1')}}</div>-->
    <!--        <div class="no_info_text">-->
    <!--          <span class="cursor" @click="toNotice">{{$t('flowFollowUs2')}}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      &lt;!&ndash; 有未读公告 &ndash;&gt;-->
    <!--      <div class="yes_info" v-else-if="infoDialog">-->
    <!--        <div class="yes_info_top">{{$t('flowFollowUs3')}}</div>-->
    <!--        <div class="yes_info_li cursor"-->
    <!--             @click="toInfo(item)"-->
    <!--             v-for="item in noticeList"-->
    <!--             :key="item.noticeId">-->
    <!--          <div class="yes_info_li_title">-->
    <!--            {{item.noticeTitle}}-->
    <!--          </div>-->
    <!--          <div class="yes_info_li_time">-->
    <!--            {{item[$t('flowMessage39')] ? item[$t('flowMessage39')] : item.publishTimeStr}}-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="yes_info_bottom">-->
    <!--          <span class="cursor" @click="toNotice">{{$t('flowFollowUs4')}}</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </transition>-->
    <!--    &lt;!&ndash; <transition name="fade">-->
    <!--    </transition> &ndash;&gt;-->
    <!--  </div>-->
    <!--  <div class="btn cursor">-->
    <!--    <img src="https://img.webloom.cn/img/gongao.png" alt="">-->
    <!--  </div>-->
    <!--</div>-->
    <!--联系我们-->
    <div class="btnNew cursor" v-if="!showHelp" @click="advisoryFn">
      <img src="https://img.webloom.cn/Img/concantus.png" alt="" class="btnIcon lianxiIcon">
    </div>
    <!--<div class="top btn_box" v-if="!showHelp">-->
    <!--  <div class="btn cursor" @click="advisoryFn">-->
    <!--    <img src="https://img.webloom.cn/Img/lianxiwmenWx.png" alt="" class="discoloration">-->
    <!--    <div class="btnInner">-->
    <!--      &lt;!&ndash; <div class="empty"></div> &ndash;&gt;-->
    <!--      <div :class="$i18n.locale !== 'en' ? 'btnInnerText' : 'btnInnerText1'">{{$t('flowFollowUs8')}}</div>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <!--<div class="top btn_box" v-if="!showHelp">-->
    <!--  <div class="btn cursor" @mouseover="showCodeEnter"  @mouseout="showCodeOut">-->
    <!--    <img src="https://img.webloom.cn/img/weixinCode.png" alt="" class="discoloration">-->
    <!--    <div class="btnInner">-->
    <!--      &lt;!&ndash; <div class="empty"></div> &ndash;&gt;-->
    <!--      <div :class="$i18n.locale !== 'en' ? 'btnInnerText' : 'btnInnerText1'">{{$t('flowFollowUs5')}}</div>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <!--<div class="top btn_box" v-if="!showHelp">-->
    <!--  <div class="btn cursor" @click="toComplaint">-->
    <!--    <img src="https://img.webloom.cn/img/liaxi.png" alt="" class="discoloration">-->
    <!--    <div class="btnInner">-->
    <!--      &lt;!&ndash; <div class="empty"></div> &ndash;&gt;-->
    <!--      <div :class="$i18n.locale !== 'en' ? 'btnInnerText' : 'btnInnerText1 btnInnerText2'">{{$t('mine.messageUs')}}</div>-->
    <!--    </div>-->
    <!--  </div>-->
    <!--</div>-->
    <!-- 回到顶部 -->
    <div class="btnNew cursor" @click="$utils.backTop(1000)" v-if="topBol">
      <img src="https://img.webloom.cn/Img/allbtnTop.png" alt="" class="btnIcon topIcon">
    </div>
    <!--<div class="top btn_box" v-if="!showHelp">-->
    <!--  <div class="btn cursor" @click="$utils.backTop(1000)" v-if="topBol">-->
    <!--    <img src="https://img.webloom.cn/img/toTop.png" alt="">-->
    <!--  </div>-->
    <!--</div>-->

    <!-- 智能客服弹窗 -->
    <div class="smart-service" v-show="!showHelp">
      <!-- 客服对话框 -->
      <transition name="service-fade">
        <div class="service-dialog" v-show="serviceDialogVisible" v-loading="customerLoading">
          <!-- 对话框头部 -->
          <div class="dialog-header">
            <div class="header-left">
              <div class="header-info">
                <!--Bloom智能客服-->
                <div class="service-name">{{$t('customer10')}}</div>
              </div>
            </div>
            <div class="header-right">
              <img class="header-close" src="https://img.webloom.cn/img/activityClose.png" alt="" @click="closeServiceDialog">
            </div>
          </div>

          <!-- 对话内容区域 -->
          <div class="dialog-content" ref="dialogContent" @scroll="handleDialogScroll">
            <!-- 聊天消息列表 -->
            <div class="message-list" v-for="(item, index) in chatList" :key="index">
              <!-- 用户消息 -->
              <div class="message-item user-message" v-if="item.operType >= 0 && item.operType <= 40">
                <div class="message-content">
                  <div class="message-time">{{$utils.timestampToStr(item.questionSendTime, 'Y.M.D h:m:s')}} <span style="color: #030A17">{{$t('customer14')}}</span></div>
                  <pre class="message-bubble user-bubble">{{item.question}}</pre>
                </div>
                <div class="avatar">
                  <img :src="hearderImg" alt="" onerror="this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null"  class="avatar">
                </div>
              </div>
              <!--后台记录类型  11 直接匹配回答 12 模糊匹配问答 13 id获取答案 20 未知回答 30 问候 40 转人工 70 以上都不是-->
              <!--前端类型 -1 周期问候语 -2 用来展示top5-->
              <!--11-30 需要展示用户发送的东西 其他的不用-->
              <!-- 客服消息 -->
              <div class="message-item service-message" >
                <div class="avatar">
                  <img src="https://img.webloom.cn/Img/customerImg1.png" alt="客服头像">
                </div>
                <div class="message-content" >
                  <div class="service-name"><span style="color: #030A17">{{$t('customer10')}}</span> {{$utils.timestampToStr(item.answerSendTime, 'Y.M.D h:m:s')}}</div>
                  <!--标准回答-->
                  <div class="message-bubble service-bubble" v-if="(item.operType > 10 && item.operType < 20) && !item.waitAnswer">
                    <pre class="message-bubble-question">{{item.answer.question}}</pre>
                    <pre class="message-bubble-answer messageTxt">{{item.answer.answer}}</pre>
                    <!--相关问题-->
                    <!--{{item.answer.questionSimilarList}}-->
                    <div class="related_issues" v-if="item.operType === 12 && item.answer && item.answer.questionSimilarList && item.answer.questionSimilarList.length > 0">
                      <!--其他与本次咨询相关的问题-->
                      <div class="related_issues_title">{{$t('customer16')}}</div>
                      <div class="related_issues_item cursor" @click="handleQuestionClick(q2,  item.talkLogId)" v-for="(q2, i) in item.answer.questionSimilarList" :key="i">
                        <div class="related_issues_item_txt ellipsis">{{q2.question}}</div>
                        <img src="https://img.webloom.cn/Img/customerImg6.png" alt="" class="right-img">
                      </div>
                    </div>
                    <!--以上都不是-->
                    <div class="None_above" @click="solve(item, 70)" v-if="item.operType == 12">{{$t('customer3')}}</div>
                  </div>
                  <!--触发人工-->
                  <!--<div class="message-manual" v-if="item.operType === 200">-->
                  <!--  <pre class="message-manual-txt">当前人工客服不在线，你可以发起留言咨询，或者查看咨询老师的联系方式～</pre>-->
                  <!--  <div class="message-manual-btn">前往留言咨询</div>-->
                  <!--</div>-->
                  <!--以上都不是 、未解决、im652、 operType 20 未知回答-->
                  <!--很抱歉，你可以重新向我描述问题，或者点击下方文字，进入留言咨询页面，将有人工为你解答问题～-->
                  <div class="message-manual" v-if="item.operType === 20 || item.operType === 60 || item.operType === 70">
                    <pre class="message-manual-txt">{{$t('customer4')}}</pre>
                    <div class="message-manual-btn cursor" @click="makeComplaint">{{$t('customer5')}}</div>
                  </div>
                  <div class="message-manual" v-if="item.operType === 30">
                    <pre class="message-manual-txt">{{$t('customer2')}}</pre>
                  </div>
                  <!--识别为问候语 会话首次进入-->
                  <!--你好，我是Bloom智能客服，你可以向我咨询平台使用或活动规则等问题，我会尽我所能为你解答～-->
                  <div class="message-manual" v-if="item.operType === -2">
                    <pre class="message-manual-txt">{{$t('customer1')}}</pre>
                  </div>
                  <!--top5-->
                  <div class="message-top5" v-if="top5obj && item.operType == -1">
                    <div class="message-top5-title">{{$t('customer9')}}</div>
                    <div class="message-top5-question-list">
                      <div class="message-top5-question cursor" @click="handleQuestionClick(q3)" v-for="(q3, i) in top5obj && top5obj.topFiveQuestion" :key="i">
                        <pre class="question ellipsis">{{q3.question}}</pre>
                        <img src="https://img.webloom.cn/Img/customerImg6.png" alt="" class="right-img">
                      </div>
                    </div>
                  </div>
                  <!--回答loding-->
                  <div class="message-loadding" v-if="item.waitAnswer">
                    <!--<img src="https://img.webloom.cn/Img/huidaloadding.png" alt="" class="loading-icon">-->
                    <img src="https://img.webloom.cn/Img/chatLodding.gif" alt="loading-icon1" class="loading-icon1">
                    <span class="loading-text">{{$t('customer17')}}<span class="loading-dots"></span></span>
                  </div>
                </div>
              </div>
              <!--解决状态-->
              <!--是否解决 10 未标记 20 未解决 30 已解决 40 无需标记-->
              <div class="resolved-status" v-if="(item.solveStatus == 10 || item.solveStatus == 20 || item.solveStatus == 30)">
                <div class="yes" @click="solve(item, 50)" :class="+item.solveStatus == 10 ? 'not' : ''"  v-if="+item.solveStatus !== 20">
                  <img src="https://img.webloom.cn/Img/yes1.png" alt="" class="status_img" v-if="+item.solveStatus == 10">
                  <img src="https://img.webloom.cn/Img/yes2.png" alt="" class="status_img" v-if="+item.solveStatus == 30">
                  <div class="status_txt">{{$t('customer7')}}</div>
                </div>
                <div class="no" @click="solve(item, 60)" :class="+item.solveStatus == 10 ? 'not' : ''" v-if="+item.solveStatus !== 30">
                  <img src="https://img.webloom.cn/Img/no1.png" alt="" class="status_img"  v-if="item.solveStatus == 10">
                  <img src="https://img.webloom.cn/Img/no2.png" alt="" class="status_img" v-if="item.solveStatus == 20">
                  <div class="status_txt">{{$t('customer8')}}</div>
                </div>
              </div>

            </div>
          </div>
          <!-- 输入区域 -->
          <div class="dialog-input">
            <div class="dialog-btn">
              <div class="btn" @click="contactHuman">
                <img src="https://img.webloom.cn/Img/customerImg3.png" alt="" class="weixin">
                <div class="btn-txt">{{$t('customer11')}}</div>
              </div>
              <div class="btn" @click="makeComplaint">
                <img src="https://img.webloom.cn/Img/customerImg4.png" alt="" class="weixin">
                <div class="btn-txt">{{$t('customer12')}}</div>
              </div>
            </div>
            <div class="input-container">
              <img data-v-1148cf8c="" src="https://img.webloom.cn/Img/chatSend.png" alt="" class="send" @click="sendMessage">
              <input
                id="inputContainer"
                ref="inputContainer"
                type="text"
                @focus="messageFocus"
                v-model="inputMessage"
                @beforeinput="onBeforeInput"
                @keydown="sendMessage"
                @compositionstart="onCompositionStart"
                @compositionend="onCompositionEnd"
                :placeholder="lodding ? $t('customer21') : $t('customer13')"
                class="message-input"
                maxlength="500"
                :readonly="lodding"
              >
            </div>
          </div>
        </div>
      </transition>
    </div>

    <span v-show="false">{{language}}</span>
    <speakToStudent v-if="showHelp" :showHelp="showHelp"></speakToStudent>
    <!-- 学术公告居中弹窗（保留弹窗，右下角铃铛图标隐藏） -->
    <el-dialog
      custom-class="task_list_dialog_all"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      :lock-scroll="true"
      width="1000px">
      <div slot="title" class="dialog-title-all">
        <div class="title-right">
          <img src="https://img.webloom.cn/img/gonggaoicontc.png" alt="" class="iconImg">
          <div class="title">{{dialogTitle.title}}</div>
        </div>
        <div class="time">{{dialogTitle.time}}</div>
      </div>
      <noticeInfo :model="2" :noticeId="userLatestNoticeInfo.noticeId || ''" v-if="dialogVisible" :topicId="noticeTopicId" @getdialogTitle="getdialogTitle" @close="toclose" :noticeNo="noticeNo"></noticeInfo>
    </el-dialog>
  </div>
</template>

<script>
import SVGA from 'svgaplayerweb'
import faceTipBox1 from '../bloom-proctor/public/faceTipBox.vue'
import speakToStudent from '../bloom-proctor/public/speakToStudent.vue'
import {loginTim, logoutTim, JoinGroupIM} from '../bloom-proctor/public/createIMClient'
import { mapState, mapMutations } from 'vuex'
import CloseStream from '../bloom-proctor/public/closeStream'
import noticeInfo from '../team-message/notice-info.vue'
import { getCustomerIMInstance, setCustomerIMMessageHandler } from '../../assets/js/customerImClient'
import { ensureCustomerImReady, destroyCustomerImOnError } from '../../assets/js/customerImBootstrap'
import { fetchActivityLoginState, getRouteSeasonId, getRouteContestId, fetchActivityUnreadCount, fetchActivityUnreadNoticeList, isActivityHomeChromeRoute } from '@/utils/activityHome'

const NOTICE_AUTO_POPUP_KEY = 'ahNoticeAutoPopup:'
export default {
  components: {
    noticeInfo,
    faceTipBox1,
    speakToStudent
  },
  computed: {
    ...mapState({
      tim: state => state.test.tim,
      customerTim: state => state.customerIm.tim,
      imGroupId: state => state.proctor.imGroupId,
      joinGroupSuccess: state => state.proctor.joinGroupSuccess,
      timerCamera: state => state.proctor.timerCamera,
      cameraClient: state => state.proctor.cameraClient,
      cameraStream: state => state.proctor.cameraStream,
      timerErrorCamera: state => state.proctor.timerErrorCamera,
      imNeedReconnect: state => state.proctor.imNeedReconnect
    }),
    // 是否含有该路由
    routeList () {
      for (let i in this.pathList) {
        if (this.$route.path.toUpperCase().indexOf(this.pathList[i].toUpperCase()) > -1) {
          return false
        }
      }
      return true
    },
    // 求助是否展示
    showHelp () {
      for (let i in this.helpList) {
        if (this.$route.path.toUpperCase().indexOf(this.helpList[i].toUpperCase()) > -1) {
          this.hisShowHelp = true
          return true
        }
      }
      this.hisShowHelp = false
      return false
    },
    language () {
      return this.$i18n.locale === 'en' ? 'en' : 'zh'
    },
    /** 壳子四 Tab 或旧 Allbtn_info：展示铃铛，并走公告提示 */
    showNoticeBell () {
      const meta = this.$route.meta || {}
      return !!(meta.Allbtn_info || meta.activityHomeChrome) && !this.showHelp
    },
    noticeTopicId () {
      return getRouteSeasonId(this.$route)
    }
  },
  data () {
    return {
      hisShowHelp: false,
      t: new Date().getTime(),
      dialogTitle: {
        title: '',
        time: ''
      },
      topicId: '',
      dialogVisible: false,
      noticeNo: 0,        // 未读公告数量
      noticeList: [],     // 公告列表
      userLatestNoticeInfo: {}, // 弹窗信息对象
      infoDialog: false,  // 消息弹窗
      infoTimer: null,
      infoBolTimer: null, // 有未读时的弹框
      topBol: false,      // 返回顶部按钮显示隐藏
      // 写作，考试，和tdpt
      pathList: ['tdpt/', '/ExamPaper', '/WritingTask', '/AnswerRoom', '/QuestionRoom', '/unsubscribe'],   // 不要显示的路由
      // 监考,迟到,进入考试页,考试结束
      helpList: ['/bloomEquipment', '/waitingExamination', '/BattleList', '/BattleRoom', '/BattleResult', '/SuperQuizNew', '/SuperQuizPaperNew', '/SuperQuizEndNew', '/ExamSystemMiss', '/ExamSystemIndex', '/ExamSystemEnd', '/ExamSystemPaper', '/ExamSystemEND'],
      showCode: false,
      customerLoading: false, // 加载中
      // 智能客服相关数据
      serviceDialogVisible: false,  // 客服对话框显示状态
      inputMessage: '',             // 输入框内容
      messageList: [],              // 消息列表
      hearderImg: '',
      top5obj: null, // top5对象
      messages: [],
      chatList: [], // 聊天记录
      // 分页相关
      pageSize: 20, // 每页查询条数
      startIndex: 0, // 查询起始位置
      hasMoreData: true, // 是否还有更多数据
      isLoading: false, // 是否正在加载
      isInitialLoad: true, // 是否为首次加载
      // 防抖相关
      scrollTimer: null,
      loadMoreTimer: null,
      talkLogId: '', // 当前等待回复的聊天记录id一问一答公用一条
      lodding: false, // 为true时还在等待im消息
      customertim: null, // 客服im实例
      contestId: '',
      // 防抖定时器
      scrollDebounceTimer: null,
      // 防抖节流相关变量
      sendMessageDebounceTimer: null, // 防抖定时器
      sendMessageThrottleTimer: null, // 节流定时器
      lastSendTime: 0, // 上次发送时间
      isThrottling: false, // 是否正在节流中
      debounceDelay: 300, // 防抖延迟时间(毫秒)
      throttleDelay: 1000, // 节流间隔时间(毫秒)
      // 浏览器兼容标记
      isSafari: false, // 是否为 Safari 浏览器
      // 输入法与键盘交互状态
      isComposing: false, // 标记输入法是否处于合成状态（IME composing）
      pendingEnter: false, // 记录在合成期按下的 Enter
      compositionEndTimer: null, // 合成结束后的延迟处理定时器
      safariImeFallbackTimer: null, // Safari 合成兜底定时器
      lastCompositionTime: 0, // 最近一次合成事件时间戳
      safariCompositionGuardDelay: 80, // Safari下在合成结束后的保护延迟窗口(ms)
      safariPreeditActive: false // Safari 下 preedit 候选阶段标记
    }
  },
  methods: {
    ...mapMutations(['set_imMessageList', 'set_imNeedReconnect', 'set_timerCamera', 'set_TIMMessage', 'set_timerErrorCamera', 'set_joinGroupSuccess']),
    // 信息的移进来
    getdialogTitle (e) {
      this.dialogTitle = e
    },
    toclose () {
      this.dialogVisible = false
    },
    infoMouseover () {
      clearTimeout(this.infoTimer)
      clearTimeout(this.infoBolTimer)
      this.infoDialog = true
    },
    // 信息的移出去
    infoMouseout () {
      this.infoTimer = setTimeout(() => {
        this.infoDialog = false
      }, 300)
    },
    // 跳转立即执行
    advisoryFn () {
      this.$router.push('/contact')
      this.$utils.CzcTrackEvent(this.$route.name, '全局报名咨询点击', '')
    },
    // 滚动条事件
    scrollup (e) {
      // 变量t是滚动条滚动时，距离顶部的距离
      let t = document.documentElement.scrollTop || document.body.scrollTop
      // 当滚动到距离顶部200px时，返回顶部的锚点显示
      this.topBol = t >= 200
    },
    // 去公告详情
    toInfo (item) {
      if (item.isRead === 0) {
        item.isRead = 1
        this.noticeNo = this.noticeNo - 1
        // 未读公告减一
      }
      this.userLatestNoticeInfo = item
      this.dialogVisible = true
    },
    toComplaint () {
      this.$router.push('/workOrder')
      this.$utils.CzcTrackEvent(this.$route.name, '留言咨询点击', '')
    },
    noticeAutoPopupKey (seasonId) {
      return NOTICE_AUTO_POPUP_KEY + String(seasonId || '')
    },
    /** 已为该活动自动提示过的最新公告 id（切 Tab 不重复；新公告可再弹） */
    getShownNoticeId (seasonId) {
      if (!seasonId) return ''
      try {
        return String(sessionStorage.getItem(this.noticeAutoPopupKey(seasonId)) || '')
      } catch (e) {
        return ''
      }
    },
    markShownNoticeId (seasonId, noticeId) {
      if (!seasonId || noticeId == null || noticeId === '') return
      try {
        sessionStorage.setItem(this.noticeAutoPopupKey(seasonId), String(noticeId))
      } catch (e) {}
    },
    /** 壳子四页：已登录才拉公告；同一条最新公告切 Tab 不重复弹，新公告仍可弹；
     *  注意：右下角铃铛图标可隐藏，但自动弹窗行为仍生效，所以不再要求 showNoticeBell 为真
     *  去重粒度：按「seasonId + 路由 path」—— 同一个 Tab 内 mounted + watch.$route 并发只打一次；
     *  四 Tab（详情/任务/学习中心/通知）之间切换 path 会变 → 每次切 Tab 都重新请求
     *  仅活动壳子四页请求；TaskSublist 等非壳子页不拉未读公告
     */
    syncChromeNoticePopup () {
      if (!isActivityHomeChromeRoute(this.$route)) return
      const seasonId = getRouteSeasonId(this.$route)
      if (!seasonId) return
      const path = (this.$route && this.$route.path) || ''
      const key = String(seasonId) + '|' + path
      if (this._lastPopupKey === key) return
      this._lastPopupKey = key
      this.infoDialog = false
      fetchActivityLoginState(this).then(ok => {
        if (!ok) return
        this.getNoticeInfo(seasonId)
      })
    },
    // 获取公告未读数；有未读再拉列表决定是否自动弹
    // 注意：不再直接 $api.post GET_UNREADCOUNT，改走 activityHome.fetchActivityUnreadCount
    //       这样与 chrome.vue 的 fetchUnread 共用同一套 in-flight 去重 + 结果缓存，避免活动四页双请求
    getNoticeInfo (seasonId) {
      if (!isActivityHomeChromeRoute(this.$route)) return
      const sid = seasonId || getRouteSeasonId(this.$route)
      if (!sid) return
      const run = () => {
        fetchActivityUnreadCount(this, sid)
          .then(parsed => {
            this.noticeNo = parsed.noticeNum || 0
            const num = (parsed.activityNum || 0) + this.noticeNo
            this.$store.commit('setActNum', num)
            if (+this.noticeNo !== 0) {
              this.getNoticeList(sid)
            }
          })
          .catch(() => {})
      }
      fetchActivityLoginState(this).then(ok => {
        if (ok) run()
      })
    },
    // 获取未读公告列表并按最新 noticeId 决定是否自动弹
    // 注意：不再直接 $api.post COMMON_NOTICE_UNREAD，改走 activityHome.fetchActivityUnreadNoticeList
    //       与 mounted / watch.$route 的并发调用复用同一套 in-flight 去重 + 缓存，避免四页双请求
    getNoticeList (seasonId) {
      if (!isActivityHomeChromeRoute(this.$route)) return
      const topicId = seasonId || getRouteSeasonId(this.$route)
      if (!topicId) return
      fetchActivityUnreadNoticeList(this, topicId, 3)
        .then(parsed => {
          this.noticeList = (parsed.noticeList || []).map(e => {
            e.isRead = 0
            return e
          })
          this.userLatestNoticeInfo = parsed.userLatestNoticeInfo || null
          const latest = this.userLatestNoticeInfo
          const latestId = latest && latest.noticeId != null
            ? String(latest.noticeId)
            : (this.noticeList[0] && this.noticeList[0].noticeId != null
              ? String(this.noticeList[0].noticeId)
              : '')
          // 同一条最新公告本登录已自动提示过 → 切 Tab / 刷新不重复弹
          if (latestId && this.getShownNoticeId(topicId) === latestId) {
            this.infoDialog = false
            return
          }
          this.infoDialog = true
          const shouldAutoPopup = latest && +latest.isRead === 0
          if (shouldAutoPopup) {
            this.dialogVisible = true
            this.noticeNo = this.noticeNo - 1
            if (this.noticeList[0]) this.noticeList[0].isRead = 1
          }
          if (latestId) this.markShownNoticeId(topicId, latestId)
          this.infoBolTimer = setTimeout(() => {
            this.infoDialog = false
          }, 3000)
        })
        .catch(() => {})
    },
    // 去公告列表
    toNotice () {
      this.$router.push({
        path: '/teamMessage',
        query: {
          topicId: getRouteSeasonId(this.$route),
          contestId: getRouteContestId(this.$route),
          type: 1
        }
      })
    },
    logonIm (type = 'first') {
      if (this.showHelp) {
        // 判断一下客服实例 有先退出
        // 监考登录 只能bloomUID登录
        this.$api.post('COMMON_GET_USER_SIG', {}, (res) => {
          let userSig = res.data.userSig || ''
          let appid = res.data.sdkAppId
          let userId = ''
          if (JSON.parse(this.$utils.cache('userData'))) {
            userId = JSON.parse(this.$utils.cache('userData')).userId
          }
          loginTim(appid, userId, userSig, { examId: this.$route.query.examId }, res => {
            this.set_imMessageList(res)
          }, type)
        })
      } else {
        // 判断一下监考实例 有先退出
        // 其他登录 我在这里登录我的（游客登录 或者bloomUID登录）
      }
    },
    filterEmoji (value) {
      // 更全面的emoji过滤正则表达式，包含所有Unicode emoji范围
      const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1F018}-\u{1F270}]|[\u{238C}]|[\u{2194}-\u{2199}]|[\u{21A9}-\u{21AA}]|[\u{231A}-\u{231B}]|[\u{23E9}-\u{23EC}]|[\u{23F0}]|[\u{23F3}]|[\u{25FD}-\u{25FE}]|[\u{2614}-\u{2615}]|[\u{2648}-\u{2653}]|[\u{267F}]|[\u{2693}]|[\u{26A1}]|[\u{26AA}-\u{26AB}]|[\u{26BD}-\u{26BE}]|[\u{26C4}-\u{26C5}]|[\u{26CE}]|[\u{26D4}]|[\u{26EA}]|[\u{26F2}-\u{26F3}]|[\u{26F5}]|[\u{26FA}]|[\u{26FD}]|[\u{2705}]|[\u{270A}-\u{270B}]|[\u{2728}]|[\u{274C}]|[\u{274E}]|[\u{2753}-\u{2755}]|[\u{2757}]|[\u{2795}-\u{2797}]|[\u{27B0}]|[\u{27BF}]|[\u{2B1B}-\u{2B1C}]|[\u{2B50}]|[\u{2B55}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F171}]|[\u{1F17E}-\u{1F17F}]|[\u{1F18E}]|[\u{3030}]|[\u{303D}]|[\u{3297}]|[\u{3299}]|[\u{FE0F}]|[\u{200D}]/gu
      return value.replace(emojiRegex, '')
    },
    // 初始化
    init () {
      this.chatList = []
      let Top5 = sessionStorage.getItem('haveTop5')
      if (Top5) {
        this.getChatHistory()
      } else {
        const messageRecord = {
          operType: -2, //
          answerSendTime: Date.now()
        }
        // 添加问候聊天记录
        this.chatList.push(messageRecord)
        // 获取Top5
        this.getTop5()
        sessionStorage.setItem('haveTop5', 'true')
      }
      // 检查登录状态
      this.loginJudgment()
      // this.getSvga()
      let userData = JSON.parse(this.$utils.cache('userData'))
      if (userData) {
        this.hearderImg = userData.portraitPath || ''
        this.userId = userData.userId || ''
        this.userData = userData
      } else {
        this.hearderImg = '../../assets/img/default-avatar.svg'
      }
    },
    // 获取Svga图标  更改了小图标 不用 svga动图了 使用的地方注释
    getSvga () {
      let url = ''
      // 一定要使用$nextTick，等到页面加载完成再处理数据，否则会找不到页面元素，报Undefind的错误
      this.$nextTick(() => {
        if (this.showHelp) {
          return
        }
        const h5lxwmElement = document.getElementById('h5lxwm')
        if (h5lxwmElement) {
          let player = new SVGA.Player('#h5lxwm')   // 多个svga文件同时加载
          let parser = new SVGA.Parser('#h5lxwm')       // 多个svga文件同时加载Img/kefuiconEn.svga
          // 若是单个文件，则直接获取其Id即可
          url = this.$t('flowImage2')
          parser.load(url, function (item) {
            player.setVideoItem(item)
            player.startAnimation()
          })
        }
        this.$forceUpdate()
      })
    },
    // 智能客服相关方法
    // 切换客服对话框显示状态
    toggleServiceDialog () {
      this.serviceDialogVisible = !this.serviceDialogVisible
      if (this.serviceDialogVisible) {
        this.$nextTick(() => {
          this.scrollToBottom()
        })
      }
    },
    // 关闭客服对话框
    closeServiceDialog () {
      this.serviceDialogVisible = false
    },
    // 滚动到对话框底部
    scrollToBottom () {
      if (this.$refs.dialogContent) {
        this.$refs.dialogContent.scrollTop = this.$refs.dialogContent.scrollHeight
      }
    },
    solve (item, status) {
      // 不是未解决不用管
      if (item.solveStatus !== 10 && status !== 70) return
      // 检查是否有talkLogId
      if (!item.talkLogId) {
        console.error('solve方法调用失败: 缺少talkLogId参数')
        return
      }
      // 调用TALK_STATUS_MARK接口标记为已解决
      const params = {
        talkLogId: item.talkLogId,
        operType: status // 10 提问 11 直接匹配回答 12 模糊匹配问答 13 id获取答案 20 未找到回答 30 问候 40 转人工 50 解决 60 未解决 70 以上都不是
      }
      this.$api.post('TALK_STATUS_MARK', params, (res) => {
        // 接口调用成功
        // 更新本地状态
        if (status === 50) {
          // 解决
          item.solveStatus = 30
        } else if (status === 60) {
          item.solveStatus = 20
          // 加一条很抱歉的聊天记录 生成的聊天记录id
          this.addUserMsg(res.data.talkLogId, '', 60, 40, false)
        } else if (status === 70) {
          // 以上都不是 需要添加一条聊天记录 很抱歉，你可以重新向我描述问题，或者点击下方文字，进入留言咨询页面，将有人工为你解答问题
          this.addUserMsg(res.data.talkLogId, '', 70, 40, false)
        }
      }, (error) => {
        // 接口调用失败
        console.error('状态标记失败:', error)
      })
    },
    // 往聊天记录里面添加用户聊天记录
    addUserMsg (talkLogId, message, operType, solveStatus, waitAnswer) {
      // 聊天记录是一条包含一问一答
      const messageRecord = {
        questionSendTime: Date.now(),
        questionSourceType: 10,
        question: message, // 用户问题
        talkLogId: talkLogId, // 聊天记录id
        questionUserId: '',
        questionUserName: '',
        questionPortraitPath: '',
        answerSourceType: 0,
        answerUserId: '',
        answerUserName: '',
        answerPortraitPath: '',
        answer: '',
        answerSendTime: Date.now(),
        talkLang: '', // 显示中文还是英文
        operType: operType, // 10 提问 11 直接匹配回答 12 模糊匹配问答 13 id获取答案 20 未知回答 30 问候 40 转人工 50 解决 60 未解决
        solveStatus: solveStatus || 40, // 10 未标记 20 未解决 30 已解决 40 无需标记
        waitAnswer: waitAnswer // 等待回答转圈圈
      }
      this.lodding = waitAnswer
      // 确保chatList存在
      if (!this.chatList) {
        this.chatList = []
      }
      // 添加消息到聊天记录
      this.chatList.push(messageRecord)
      // 滚动到底部显示最新消息
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 防抖函数 - 延迟执行，在指定时间内如果再次触发则重新计时
    debounce (func, delay) {
      return (...args) => {
        clearTimeout(this.sendMessageDebounceTimer)
        this.sendMessageDebounceTimer = setTimeout(() => {
          func.apply(this, args)
        }, delay)
      }
    },
    // 节流函数 - 限制单位时间内的执行次数
    throttle (func, delay) {
      return (...args) => {
        const now = Date.now()
        if (now - this.lastSendTime >= delay) {
          this.lastSendTime = now
          func.apply(this, args)
        }
      }
    },
    // 原始的sendMessage方法实现
    sendMessageOriginal () {
      if (this.lodding) {
        this.$message.error(this.$t('customer6'))
        return
      }
      if (this.inputMessage.trim()) {
        const message = this.inputMessage.trim()
        // 调用TALK_SEND_MSG发送消息
        const params = {
          // contestId: 0, // 可选参数
          question: message // 发送的消息
        }
        if (this.$route.query.contestId) {
          params.topicId = this.$route.query.contestId
          params.topicType = 10
        } else if (this.$route.params.contestId) {
          params.topicId = this.$route.params.contestId
          params.topicType = 10
        } else if (this.$route.query.taskRelationId) {
          params.topicId = this.$route.query.taskRelationId
          params.topicType = 20
        } else if (this.$route.params.taskRelationId) {
          params.topicId = this.$route.params.taskRelationId
          params.topicType = 20
        }
        this.$api.post('TALK_SEND_MSG', params, (res) => {
          // 可以在这里处理发送成功后的逻辑，比如刷新聊天记录
          // 将发送的消息添加到聊天记录中
          this.addUserMsg('', message, 10, 40, true)
          this.talkLogId = res.data.talkLogId // 聊天记录id一问一答公用一条
          // 添加用户消息
          this.chatList[this.chatList.length - 1].talkLogId = res.data.talkLogId
          // 清空输入框
          this.inputMessage = ''
        }, (error) => {
          console.error('消息发送失败:', error)
          // 可以在这里添加错误提示
        })
      }
    },
    // 带防抖节流机制的sendMessage方法（兼容IME与键盘 Enter 逻辑）
    sendMessage (e) {
      const isKeyboardEvent = e && e.type === 'keydown'
      if (isKeyboardEvent) {
        const keyCode = e.keyCode || e.which
        const isEnter = keyCode === 13 || e.key === 'Enter' || e.code === 'Enter'
        if (!isEnter) return
        const inputVal = (this.inputMessage || '').trim()
        const emptyInput = inputVal.length === 0
        const imeActive = this.isComposing || (e && e.isComposing === true)
        const recentlyComposed = (Date.now() - this.lastCompositionTime) < this.safariCompositionGuardDelay
        // 当输入框为空：按下 Enter 直接发送（即使在合成中，也在合成结束后发送）
        if (emptyInput) {
          // 优先保证各浏览器不插入换行
          if (typeof e.preventDefault === 'function') e.preventDefault()
          if (imeActive) {
            // 标记在合成期间按下了 Enter，待合成结束发送
            this.pendingEnter = true
            return
          }
          return this._sendWithRateLimit()
        }
        // 有内容时：在中文输入法状态下优先完成选词，不发送
        if (imeActive) {
          this.pendingEnter = true
          return
        }
        // Safari 兼容：在部分版本下 e.isComposing 可能不准确，使用时间窗口与preedit标记
        if (this.isSafari && (this.safariPreeditActive || recentlyComposed)) {
          // 处于候选或刚结束合成的保护窗口中：不发送，优先选词
          if (typeof e.preventDefault === 'function') e.preventDefault()
          this.pendingEnter = true
          return
        }
        // 非合成且有内容：正常发送
        if (typeof e.preventDefault === 'function') e.preventDefault()
        return this._sendWithRateLimit()
      }
      // 非键盘触发（比如点击发送按钮）直接走发送流程
      return this._sendWithRateLimit()
    },
    // Safari 检测（排除 iOS 上的 Chrome/Firefox）
    _detectSafari () {
      const ua = navigator.userAgent || ''
      const vendor = navigator.vendor || ''
      const isAppleVendor = vendor.indexOf('Apple') > -1
      const isCriOS = /\bCriOS\b/i.test(ua) // iOS Chrome
      const isFxiOS = /\bFxiOS\b/i.test(ua) // iOS Firefox
      const isEdge = /\bEdg\b/i.test(ua)
      return isAppleVendor && !isCriOS && !isFxiOS && !isEdge
    },
    // 合成开始事件处理
    onCompositionStart () {
      this.isComposing = true
      this.safariPreeditActive = this.isSafari ? true : this.safariPreeditActive
      this.lastCompositionTime = Date.now()
      // 清理可能存在的 pendingEnter 状态，避免误触发
      clearTimeout(this.compositionEndTimer)
    },
    // 合成结束事件处理：延迟执行，确保输入法完成提交
    onCompositionEnd () {
      this.isComposing = false
      this.safariPreeditActive = false
      this.lastCompositionTime = Date.now()
      // 如果在合成状态中按下了 Enter，则在合成结束后进行延迟处理
      if (this.pendingEnter) {
        this.pendingEnter = false
        clearTimeout(this.compositionEndTimer)
        // 小延迟以确保 Safari/Chrome/Edge/Firefox 在 macOS/Windows 下的合成提交完成
        this.compositionEndTimer = setTimeout(() => {
          const inputVal = (this.inputMessage || '').trim()
          const emptyInput = inputVal.length === 0
          // 规则：输入框为空时，按下 Enter 直接触发消息发送；有内容时不发送（优先完成选词）
          if (emptyInput) {
            this._sendWithRateLimit()
          }
          // 有内容则不做处理，保持用户的输入法选词行为
        }, 16)
      }
    },
    // Safari 及其他浏览器的 beforeinput 事件处理，用于更准确检测 IME 状态
    onBeforeInput (e) {
      try {
        const type = e && e.inputType
        // 在候选阶段（preedit），标记为合成中
        if (type === 'insertCompositionText' || type === 'deleteCompositionText') {
          this.isComposing = true
          this.lastCompositionTime = Date.now()
          if (this.isSafari) this.safariPreeditActive = true
          return
        }
        // 提交阶段：insertText 通常表示组合文本被提交
        if (type === 'insertText') {
          this.isComposing = false
          this.lastCompositionTime = Date.now()
          if (this.isSafari) this.safariPreeditActive = false
        }
      } catch (err) {

      }
    },
    // 统一的节流/防抖发送入口
    _sendWithRateLimit () {
      const now = Date.now()
      // 首先进行节流检查 - 如果距离上次发送时间小于节流间隔，则忽略本次调用
      if (this.isThrottling || (now - this.lastSendTime < this.throttleDelay)) {
        console.log('消息发送被节流限制')
        return
      }
      // 设置节流状态
      this.isThrottling = true
      // 清除之前的防抖定时器
      clearTimeout(this.sendMessageDebounceTimer)
      // 使用防抖机制延迟执行（与原逻辑保持一致）
      this.sendMessageDebounceTimer = setTimeout(() => {
        // 执行原始的发送消息逻辑
        this.sendMessageOriginal()
        // 更新最后发送时间
        this.lastSendTime = Date.now()
        // 设置节流定时器，在节流间隔后重置节流状态
        clearTimeout(this.sendMessageThrottleTimer)
        this.sendMessageThrottleTimer = setTimeout(() => {
          this.isThrottling = false
        }, this.throttleDelay)
      }, this.debounceDelay)
    },
    contactHuman () {
      // 跳转到联系我们页面
      this.serviceDialogVisible = false
      this.$message.success(this.$t('customer19'))
      this.$router.push('/contact')
    },
    makeComplaint () {
      // 跳转到留言咨询列表页面
      this.serviceDialogVisible = false
      this.$message.success(this.$t('customer18'))
      this.$router.push('/workOrder')
    },
    /**
     * 拉取签名并登录全局客服 IM（与伴学助手共用 customerImBootstrap，单例 + 并发合并）
     */
    async pullCustomerImSession () {
      this.customerLoading = true
      try {
        await ensureCustomerImReady({
          limitPost: this.$api.limitPost.bind(this.$api),
          post: this.$api.post.bind(this.$api),
          cookie: this.$cookie,
          utils: this.$utils,
          onMessage: this.handleIMMessage,
          onLoginState: (res, err) => {
            const code = res && res.code !== undefined ? res.code : (err && err.code)
            if (code === 0) {
              this.isLogin = true
            } else if (code === 10016) {
              this.isLogin = false
            }
          }
        })
        this.customertim = getCustomerIMInstance()
      } catch (e) {
        console.error('customer IM ensure', e)
      } finally {
        this.customerLoading = false
      }
    },
    // 获取top5
    getTop5 () {
      // TALK_GET_TOP5
      let data = {
        topicId: '',
        topicType: this.contestId ? 20 : 10,
        talkLang: this.$i18n.locale === 'en' ? 'en_US' : 'zh_CN'
      }
      this.$api.post('TALK_GET_TOP5', data, (res) => {
        this.top5obj = res.data || null
        if (this.top5obj && this.top5obj.topFiveQuestion && this.top5obj.topFiveQuestion.length > 0) {
          const messageRecord = {
            operType: -1, //
            answerSendTime: Date.now()
          }
          // 有top5添加聊天记录
          this.chatList.push(messageRecord)
        }
        // 首次加载聊天记录
        this.getChatHistory()
      })
    },
    // 获取问题详情
    getQuestionInfo ({talkLogId, questionId, question, language}) {
      const params = {
        talkLogId: talkLogId || 0,
        questionId: questionId || 0,
        talkLang: language
      }
      // 新增一条聊天记录
      this.$api.post('TALK_GET_QUESTION_INFO', params, (res) => {
        // 可以在这里处理获取到的问题详情数据
        if (res && res.data) {
          this.addUserMsg(res.data.talkLogId, question, 13, 40, true)
        }
      }, (error) => {
        console.error('获取问题详情失败:', error)
        // 可以在这里添加错误提示
      })
    },
    // top5和相关问题处理问题点击事件
    handleQuestionClick (item, talkLogId) {
      // 还在处理其他问题
      if (this.lodding) {
        this.$message.error(this.$t('customer6'))
        return
      }
      // 调用获取问题详情的方法
      if (talkLogId) {
        // 相关问题
        item.talkLogId = talkLogId
      } else {
        // top5
        item.language = item.talkLang
      }
      // 拿题目详情
      this.getQuestionInfo(item)
    },
    // IM监听处理
    handleIMMessage (message) {
      let that = this
      try {
        // 验证消息格式
        if (!message || !message.payload || !message.payload.text) {
          console.warn('IM消息格式不正确:', message)
          return
        }
        // 解析消息内容
        let messageData
        try {
          messageData = JSON.parse(message.payload.text)
        } catch (parseError) {
          console.error('IM消息解析失败:', parseError, message.payload.text)
          return
        }
        // 确保chatList存在
        if (!this.chatList) {
          this.chatList = []
        }
        // 获取消息类型
        const chatMsgType = messageData.chatMsgType
        console.log('收到IM消息:', {
          chatMsgType,
          messageData,
          timestamp: new Date().toISOString()
        })
        if (chatMsgType) {
          // 最后一条消息（等待im回答的消息）
          // let lastMsg = this.chatList[this.chatList.length - 1] || null
          let lastMsg = this.chatList.find(item => item.talkLogId === messageData.chatMsgId) || null
          if (!lastMsg) return
          // 滚动到底部显示最新消息
          //   operType: operType, // 10 提问 11 直接匹配回答 12 模糊匹配问答 13 id获取答案 20 未知回答 30 问候 40 转人工 50 解决 60 未解决
          //   waitAnswer: true // 等待回答转圈圈
          lastMsg.answerSendTime = messageData.answerSendTime // 回答时间
          lastMsg.waitAnswer = false
          switch (chatMsgType) {
            case 650: // 直接匹配问题
              // messageData
              lastMsg.operType = 11
              lastMsg.solveStatus = 10 // 改为未标记
              lastMsg.answer = messageData //
              that.lodding = false
              lastMsg.waitAnswer = false
              break
            case 651: // 模糊匹配问题
              lastMsg.operType = 12
              lastMsg.solveStatus = 10  // 改为未标记
              lastMsg.answer = messageData //
              that.lodding = false
              lastMsg.waitAnswer = false
              break
            case 652: // 未匹配问题 无法索引
              // 添加消息到聊天记录
              lastMsg.operType = 20
              lastMsg.solveStatus = 40 // 不需要标记
              that.lodding = false
              lastMsg.waitAnswer = false
              break
            case 653: // 问候语
              lastMsg.operType = 30
              lastMsg.solveStatus = 40 // 不需要标记
              that.lodding = false
              lastMsg.waitAnswer = false
              break
            case 654: // 以上都不是我想要咨询的问题

              break
            case 655: // 解决/未解决 // 如果是为解决需要加一条话术
              lastMsg.operType = 60
              break
            default:
              // 其他类型的消息不做处理
              console.log('未处理的消息类型:', chatMsgType)
              break
          }
          this.$nextTick(() => {
            this.scrollToBottom()
          })
        }
        // 根据chatMsgType进行差异化处理
      } catch (error) {
        console.error('处理IM消息时发生错误:', error)
        // 可以在这里添加错误上报逻辑
        this.$api && this.$api.logPost && this.$api.logPost({
          a: 74007,
          c: 'IM消息处理异常',
          r: '/',
          e: error,
          uid: this.userData ? this.userData.userId : '',
          ua: this.userAgent
        })
      }
    },
    // 获取聊天记录
    async getChatHistory (isLoadMore = false) {
      // 防止重复请求
      if (this.isLoading) {
        return Promise.resolve()
      }
      // 如果没有更多数据且不是首次加载，直接返回
      if (!this.hasMoreData && !this.isInitialLoad) {
        return Promise.resolve()
      }
      this.isLoading = true
      return new Promise((resolve, reject) => {
        try {
          const params = {
            pageSize: this.pageSize,
            startIndex: isLoadMore ? this.startIndex : 0
          }
          // 这里使用实际的API接口名称，需要根据项目实际情况调整
          this.$api.post('TALK_GET_HISTORY_LIST', params, (res) => {
            if (res && res.data) {
              let newMessages = res.data.list || []
              newMessages = newMessages.map(e => {
                e.answer =  e.answer ? JSON.parse(e.answer) : ''
                return e
              })
              newMessages = newMessages.reverse()
              if (isLoadMore) {
                // 加载更多时，将新数据添加到现有数据前面（历史记录在前）
                this.chatList = [...newMessages, ...this.chatList]
              } else {
                // 首次加载时，直接设置数据
                this.chatList = [...newMessages, ...this.chatList]
                this.isInitialLoad = false
              }
              // 更新分页参数
              if (newMessages.length < this.pageSize) {
                // 如果返回的数据少于请求的数量，说明没有更多数据了
                this.hasMoreData = false
              } else {
                // 更新起始位置
                this.startIndex += newMessages.length
              }
              // 如果是首次加载，滚动到底部显示最新消息
              if (!isLoadMore) {
                this.$nextTick(() => {
                  this.scrollToBottom()
                })
              }

              this.isLoading = false
              resolve()
            } else {
              this.isLoading = false
              resolve()
            }
          }, (error) => {
            console.error('获取聊天记录失败:', error)
            this.isLoading = false
            reject(error)
          })
        } catch (error) {
          console.error('获取聊天记录异常:', error)
          this.isLoading = false
          reject(error)
        }
      })
    },
    // // 防抖函数
    debounce2 (func, wait) {
      return (...args) => {
        clearTimeout(this.loadMoreTimer)
        this.loadMoreTimer = setTimeout(() => func.apply(this, args), wait)
      }
    },
    // 对话框滚动处理方法
    handleDialogScroll (event) {
      const dialogContent = event.target
      const scrollTop = dialogContent.scrollTop
      // 清除之前的防抖定时器
      if (this.scrollDebounceTimer) {
        clearTimeout(this.scrollDebounceTimer)
      }
      // 防抖处理，300ms后执行
      this.scrollDebounceTimer = setTimeout(() => {
        // 当滚动到顶部附近时（距离顶部小于50px），触发加载更多历史记录
        if (scrollTop <= 50 && this.hasMoreData && !this.isLoading) {
          // 记录当前滚动位置，用于加载完成后恢复位置
          const currentScrollHeight = dialogContent.scrollHeight
          // 调用getChatHistory方法加载20条历史聊天记录
          this.getChatHistory(true).then(() => {
            // 加载完成后恢复滚动位置，保持用户当前查看的内容不变
            this.$nextTick(() => {
              const newScrollHeight = dialogContent.scrollHeight
              const heightDiff = newScrollHeight - currentScrollHeight
              dialogContent.scrollTop = scrollTop + heightDiff
            })
          }).catch((error) => {
            console.error('加载历史聊天记录失败:', error)
          })
        }
      }, 300) // 300ms防抖延迟
    },
    // 调用接口判断登录再去拿签名登录im（逻辑在 customerImBootstrap.ensureCustomerImReady）
    loginJudgment () {
      this.pullCustomerImSession()
    },
    // 客服im报错时的错误吃力方法
    async handleLogoutOnError () {
      if (!this.customertim && !this.customerTim) {
        return
      }
      await destroyCustomerImOnError()
      this.customertim = null
    },
    // 判断im是否存在
    messageFocus () {
      if (!this.customertim && !this.customerTim) {
        // 没有重试登录
        this.customerLoading  = true
        this.hasMoreData = true
        this.isInitialLoad = true
        this.isLoading = false
        this.init()
      }
    }
  },
  created () {
    // 生成时检测是否为 Safari 浏览器
    this.isSafari = this._detectSafari()
    // this.getSvga()
    this.contestId = this.$route.params.contestId
    window.addEventListener('scroll', this.scrollup, false)
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.inputContainer) {
        const inputField = document.getElementById('inputContainer')

        // 监听输入法状态
        inputField.addEventListener('compositionstart', () => {
          this.isComposing = true
        })
        inputField.addEventListener('compositionend', () => {
          this.isComposing = false
        })
        // 特殊处理 macOS 的 Enter 键行为
        inputField.addEventListener('', () => {})
      }
    })
    window.onpopstate = () => {
      console.log('🎉 onpopstate 被触发')
    }
    // 右下角铃铛图标隐藏，但学术公告自动弹窗仍照常执行
    this.syncChromeNoticePopup()
  },
  watch: {
    '$route' () {
      this.syncChromeNoticePopup()
    },
    imNeedReconnect: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val) {
          this.logonIm('reconnect')
        }
      }
    },
    cameraClient: {
      deep: true,
      handler: function (val) {
        if (!val && !this.showHelp && sessionStorage.getItem('cameraExamId')) {
          let data = {
            examId: sessionStorage.getItem('cameraExamId'),
            videoStatus: 2,
            videoType: 1,
            videoRecordDesc: '连接中断',
            videoRecordTime: Date.now()
          }
          this.$api.postNoLoading('TEST_INV_UPDATEVIDEOSTATUS', data, (res) => {
            sessionStorage.setItem('cameraExamId', null)
          })
        }
      }
    },
    imGroupId: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && this.tim) {
          JoinGroupIM({ groupID: this.imGroupId }, res => {
            this.set_joinGroupSuccess(true)
          })
        }
      }
    },
    tim: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (this.imGroupId && val) {
          JoinGroupIM({ groupID: this.imGroupId }, res => {
            console.log('加群成功')
          })
        }
      }
    },
    showHelp (val) {
      if (val) {
        // 先退出客服的im 保证不影响考试
        this.handleLogoutOnError()
        // 登录考试的im
        this.logonIm()
        sessionStorage.setItem('bloom-pc-TimExamId', this.$route.query.examId)
        // 考试页面取消滚动监听
        window.removeEventListener('scroll', this.scrollup, false)
      } else {
        // 非考试页面监听滚动
        window.addEventListener('scroll', this.scrollup, false)
        logoutTim()
        if (this.timerErrorCamera) {
          clearInterval(this.timerErrorCamera)
          this.set_timerErrorCamera(null)
        }
        this.set_TIMMessage({})
      }
      if (!val) {
        CloseStream(true, false)
      }
    },
    serviceDialogVisible: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (val && !this.customertim && !this.customerTim) {
          this.init()
        } else {

        }
      }
    }
  },
  beforeDestroy () {
    // 移除全局滚动事件监听器
    window.removeEventListener('scroll', this.scrollup, false)
    // 清理防抖定时器
    if (this.scrollDebounceTimer) {
      clearTimeout(this.scrollDebounceTimer)
    }
    // 清理sendMessage相关的定时器
    if (this.sendMessageDebounceTimer) {
      clearTimeout(this.sendMessageDebounceTimer)
    }
    if (this.sendMessageThrottleTimer) {
      clearTimeout(this.sendMessageThrottleTimer)
    }
    if (this.safariImeFallbackTimer) {
      clearTimeout(this.safariImeFallbackTimer)
    }
    if (this.compositionEndTimer) {
      clearTimeout(this.compositionEndTimer)
    }
    setCustomerIMMessageHandler(null)
  }
}
</script>
<style lang="scss">
.task_list_dialog_all{
  .dialog-title-all{
    //display: flex;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #303133;
    padding-bottom: 10px;
    text-align: center;
    position: relative;
    line-height: 22px;
    .time{
      position: absolute;
      font-size: 12px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #9499A4;
      right: 34px;
      top: 0;
    }
    .iconImg {
      display: block;
      width: 108px;
      height: 56px;
      position: absolute;
      left: -12px;
      top: -12px;
    }
    .title{
      padding: 0 200px;
    }
  }
  .el-dialog__body{
    padding: 0!important;
  }
  .el-dialog__header {
    padding: 23px 20px 15px;
    background: linear-gradient(360deg, #FFFFFF 0%, #FFFFFF 16%, #D7E3FF 100%)!important;
  }
  .el-dialog__headerbtn {
    top: 25px
  }

}
  #Allbtn {
    .el-dialog__body{
      padding: 0!important;
    }
  }
</style>
<style lang="scss" scoped>

// 动画关键帧定义
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes dots {
  0%, 20% {
    content: '';
  }
  40% {
    content: '.';
  }
  60% {
    content: '..';
  }
  80%, 100% {
    content: '...';
  }
}
#Allbtn{
  .faceTipBox{
    position:fixed;
    bottom: 24px;
    right: 24px;
  }
  position: fixed;
  z-index: 5001;
  bottom: 80px;
  right: 0px;
  // 新客服图标
  .kefuBox {
    margin-top: 10px;
    width: 36px;
    padding: 12px 0px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px #D7DADF;
    border-radius: 18px;
    border: 1px solid #ECEDF5;
    display: flex;
    align-items: center;
    justify-content: center;
    .kefuImgen {
      display: block;
      width: 19px;
    }
    .kefuImgcn {
      display: block;
      width: 14px;
    }
  }
  .kefuBox:hover {
    background: #DCE7FF;
    box-shadow: 0px 0px 4px 0px #D7DADF;
    border-radius: 18px;
    border: 1px solid #ECEDF5;
  }
  .btnNew {
    margin-top: 10px;
    width: 36px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #ECEDF5;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    .btnIcon {
      //border-radius: 50%;
    }
    .topIcon{
      width: 23px;
      height: 28px;
      display: block;
    }
    .lingdangIcon {
      width: 17px;
      height: 21px;
      display: block;
    }
    .lianxiIcon {
      width: 20px;
      height: 17px;
      display: block;
    }
  }
  .btnNew:hover {
    background: #DCE7FF;
    box-shadow: 0px 0px 4px 0px #D7DADF;
    border-radius: 18px;
    border: 1px solid #ECEDF5;
  }
  .btn_box{
    //width: 68px;
    //height: 68px;
    margin-top: 8px;
    //margin-left: 20px;
    .btn{
      color: #C0C6CA;
      text-align: center;
      img{
        width: 68px;
        height: 68px;
      }
      .blpc{
        line-height: 40px;
      }
    }
    .btnInner{
      text-align: center;
      width: 68px;
      height: 68px;
      border-radius: 50%;
      padding: 14px 0 14px 10px;
      box-sizing: border-box;
      display: none;
      background-color: #1775FF;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFFFFF;
      .btnInnerText{
        width: 58px;
        height: 40px;
        line-height: 20px;
        white-space: pre-wrap;
        word-break: break-word;
        letter-spacing: 10px;
      }
      .btnInnerText3{
        width: 58px;
        height: 40px;
        line-height: 20px;
        white-space: pre-wrap;
        word-break: break-word;
        letter-spacing: 10px;
      }
      .btnInnerText1{
        //width: 100%;
        width: 52px;
        height: 40px;
        //line-height: 20px;
        white-space: pre-line;
        word-break: break-word;
        //padding-right: 10px;
        font-size: 12px;
      }
      .btnInnerText2{
        width: 52px;
        //margin-right: 20px;
        //line-height: 40px;
      }
      .empty{
        // margin-bottom: 10px;
        // height: 1px;
      }
    }
    .btn:hover{
      //background-color: #1775FF;
      //color: #fff;
      //img {
      //  display: none;
      //}
    }
  }
  .btn_box:hover{
    .btn{
      .discoloration {
        display: none;
      }
      .btnInner{
        display: block;
      }
    }
  }
  .info{
    position: relative;
    .info_new{
      width: 37px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: -18px;
      background: #FF3049;
      border-radius: 4px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      color: #fff;
    }
    .no_info{
      position: absolute;
      width: 304px;
      height: 120px;
      background: #FFFFFF;
      box-shadow: 0 -2px 4px 0 #F4F9FF, 0 8px 16px 0 #F5F7FA;
      border: 4px;
      left: -350px;
      top: -60px;
      text-align: center;
      padding-top: 32px;
      box-sizing: border-box;
      .no_info_title{
        font-size: 16px;
        line-height: 21px;
        margin-bottom: 16px;
      }
      .no_info_text{
        line-height: 19px;
        color: #296BFF;
      }
    }
    .no_info::after{
      content: '';
      display: block;
      position: absolute;
      border-bottom: 6px solid transparent;
      border-top: 6px solid transparent;
      border-left: 8px solid #FFFFFF;
      border-right: 8px solid transparent;
      right: -16px;
      top: 54px;
    }
    .yes_info{
      width: 304px;
      position: absolute;
      left: -340px;
      bottom: -200px;
      background: #fff;
      box-shadow: 0 -2px 4px 0 #F4F9FF, 0 8px 16px 0 #F5F7FA;
      border-radius: 8px;
      .yes_info_top{
        color: #fff;
        border-radius: 8px 8px 0 0;
        padding:16px;
        font-size: 16px;
        line-height: 16px;
        background-image: linear-gradient(269deg, #469EFF 0%, #296BFF 100%);
      }
      .yes_info_li{
        padding: 16px 28px;
        border-bottom: 1px solid #F1F1F2;
        .yes_info_li_title{
          line-height: 19px;
          margin-bottom: 8px;
          position: relative;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .yes_info_li_title::after{
          content: '';
          display: block;
          width: 4px;
          height: 4px;
          background: #FF3049;
          border-radius: 50%;
          position: absolute;
          left: -12px;
          top: 8px;
        }
        .yes_info_li_time{
          color: #D4D6DB;
          font-size: 12px;
          line-height: 16px;
        }
      }
      .yes_info_bottom{
        line-height: 50px;
        color: #296BFF;
        text-align: center;
        border-radius: 0 0 8px 8px;
      }
    }
  }
  .top .btn, .info .btn{
    font-size: 32px;
  }
  .advisory{
    margin-top: 4px;
    //width: 40px;
    font-size: 0;
    line-height: 0;
    position: relative;
    right: 14px;
    .ContactUs{
        width: 120px;
        height: 120px;
        display: block;
        //position: absolute;
    }
    .erCode2{
      width: 245px;
      height: 184px;
      position: absolute;
      top: 70px;
      left: -249px;
      //display: none;
    }
    //img{
    //  width: 100%;
    //}
    .advisory_hover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #000000, $alpha: 0.1);
      border-radius: 4px;
      display: none;
    }
  }
  .advisory:hover .advisory_hover{
    display: block;
  }
  .testHelp{
    margin-top: 4px;
    margin-right: 20px;
    position: relative;
    height:40px;
    color:white;
    font-size: 16px;
    .testHelpBox{
      width: fit-content;
      line-height: 20px;
      background: #469EFF;
      padding: 10px;
    }
    .testHelp_hover{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: rgba($color: #000000, $alpha: 0.1);
      border-radius: 4px;
      display: none;
    }
  }
  .testHelp:hover .testHelp_hover{
    display: block;
  }
  .task_list_dialog{
    background: #0BC2C1;
  }

  // 智能客服样式
  .smart-service {
    position: fixed;
    bottom: 20px;
    right: 0px;
    z-index: 100000;

    .service-btn {
      width: 68px;
      height: 68px;
      background: linear-gradient(135deg, #1775FF 0%, #469EFF 100%);
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 12px rgba(23, 117, 255, 0.3);
      transition: all 0.3s ease;
      margin-bottom: 8px;
      cursor: pointer;
      pointer-events: auto;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(23, 117, 255, 0.4);
      }

      .service-icon {
        width: 24px;
        height: 24px;
        margin-bottom: 2px;
      }

      .service-text {
        font-size: 10px;
        color: #fff;
        font-weight: 500;
      }
    }

    .service-dialog {
      width: 400px;
      height: 620px;
      background-image: url("https://img.webloom.cn/Img/zhinnengBG1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      border-radius: 16px;
      position: absolute;
      bottom: 60px;
      right: 0;
      //box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .dialog-header {
        padding: 0 12px 0 67px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .header-left {
          display: flex;
          align-items: center;
          .header-info {
            .service-name {
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              font-size: 18px;
              color: #030A17;
              line-height: 25px;
              text-align: left;
              font-style: normal;
            }
          }
        }

        .header-right {
          .header-close {
            width: 18px;
            height: 18px;
            display: block;
            cursor: pointer;
          }
        }
      }

      .dialog-content {
        flex: 1;
        padding: 16px;
        overflow-y: auto;
        padding-top: 0;
        .message-item {
          margin-top: 20px;
          display: flex;
          align-items: flex-start;
          &.user-message {
            justify-content: flex-end;
            margin-top: 20px;
            .message-content {
              align-items: flex-end;
              max-width: 80%;
              margin-right: 8px;
              .message-time {
                text-align: right;
                margin-bottom: 6px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #9499A4;
                line-height: 17px;
                font-style: normal;
              }
              .message-bubble {
                white-space: pre-wrap;
                word-break: break-word;
                max-width: 316px;
                width: fit-content;
                background-color: #007AFF;
                border-radius: 8px 2px 8px 8px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                box-sizing: border-box;
                padding: 8px;
              }

              .avatar {
                width: 34px;
                height: 34px;
                border-radius: 50%;
                overflow: hidden;
                flex-shrink: 0;

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
            }
          }

          &.service-message {
            margin-top: 20px;
            .message-content {
              margin-left: 8px;
              max-width: 316px;
              .messageTxt {
                word-break: break-word;
                white-space: pre-wrap;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #212121;
                line-height: 16px;
                text-align: left;
                font-style: normal;
              }
              .messageTitle {

              }
              .service-name {
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                font-size: 12px;
                color: #9499A4;
                line-height: 17px;
                text-align: left;
                font-style: normal;
                margin-bottom: 6px;
              }
              // 客服标准回答文字
              .message-bubble {
                max-width: 316px;
                width: fit-content;
                background-color: #fff;
                box-sizing: border-box;
                color: #212121;
                border-radius: 2px 8px 8px 8px;
                position: relative;
                .message-bubble-question {
                  word-break: break-word;
                  white-space: pre-wrap;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  font-size: 12px;
                  color: #212121;
                  line-height: 16px;
                  text-align: left;
                  font-style: normal;
                }
                .message-bubble-answer {
                  margin-top: 10px;
                }
                //相关问题
                .related_issues {
                  margin-top: 24px;
                  .related_issues_title {
                    word-break: break-word;
                    white-space: pre-wrap;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 600;
                    font-size: 12px;
                    color: #212121;
                    line-height: 16px;
                    text-align: left;
                    font-style: normal;
                    //margin-bottom: 5px;
                  }
                  .related_issues_item {
                    display: flex;
                    height: 28px;
                    justify-content: space-between;
                    align-items: center;
                    border-bottom: 1px solid #E4E6EB;
                    .related_issues_item_txt {
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      font-size: 12px;
                      color: #212121;
                      line-height: 12px;
                      text-align: left;
                      font-style: normal;
                    }
                    .right-img {
                      width: 12px;
                      height: 12px;
                    }
                  }
                }
                // 以上都不是
                .None_above {
                  cursor: pointer;
                  margin-top: 6px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #296BFF;
                  line-height: 16px;
                  text-align: left;
                  font-style: normal;
                }
              }
              // top5问题
              .message-top5 {
                width: 316px;
                background: linear-gradient( 180deg, #E0EAFF 0%, #FFFFFF 100%);
                box-shadow: inset 0px 2px 5px 0px rgba(255,255,255,0.5);
                border-radius: 2px 8px 8px 8px;
                border: 2px solid #FFFFFF;
                box-sizing: border-box;
                .message-top5-title {
                  height: 28px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  font-size: 12px;
                  color: #212121;
                  line-height: 28px;
                  text-align: left;
                  font-style: normal;
                  padding: 0 12px;
                }
                .message-top5-question-list {
                  background: rgba(255,255,255,0.5);
                  border-radius: 2px 8px 8px 8px;
                  border-top: 1px solid #FFFFFF;
                  box-sizing: border-box;
                  .message-top5-question {
                    cursor: pointer;
                    display: flex;
                    box-sizing: border-box;
                    padding: 0 8px 0 10px;
                    height: 28px;
                    justify-content: space-between;
                    align-items: center;
                    border-top: 1px solid #FFFFFF;
                    .question{
                      width: 268px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      font-size: 12px;
                      color: #212121;
                      line-height: 16px;
                      text-align: left;
                      font-style: normal;
                    }
                    .right-img {
                      width: 12px;
                      height: 12px;
                    }
                  }
                  .message-top5-question:first-of-type {
                    border: none;
                  }
                }
              }
              //触发人工
              .message-manual {
                padding: 8px;
                box-sizing: border-box;
                width: 316px;
                background-color: #fff;
                color: #212121;
                border-radius: 2px 8px 8px 8px;
                position: relative;
                .message-manual-txt {
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #212121;
                  line-height: 16px;
                  text-align: left;
                  font-style: normal;
                  word-break: break-word;
                  white-space: pre-wrap;
                }
                .message-manual-btn {
                  margin-top: 12px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #296BFF;
                  line-height: 16px;
                  text-align: left;
                  font-style: normal;
                }
              }

              // 加载状态
              .message-loadding {
                display: flex;
                align-items: center;
                padding: 9px;
                box-sizing: border-box;
                max-width: 316px;
                width: fit-content;
                background-color: #fff;
                color: #212121;
                border-radius: 2px 8px 8px 8px;
                position: relative;
                .loading-icon {
                  width: 16px;
                  height: 16px;
                  margin-right: 9px;
                  animation: rotate 2.0s linear infinite;
                }
                .loading-icon1 {
                  width: 16px;
                  height: 16px;
                  margin-right: 5px;
                }

                .loading-text {
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  font-size: 12px;
                  color: #9499A4;
                  line-height: 16px;
                  text-align: left;
                  font-style: normal;

                  .loading-dots {
                    display: inline-block;
                    width: 20px;
                    text-align: left;
                    animation: dots 1.5s steps(4, end) infinite;
                  }

                  .loading-dots::after {
                    content: '';
                    animation: dots 1.5s steps(4, end) infinite;
                  }
                }
              }
            }
          }

          .avatar {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            overflow: hidden;
            flex-shrink: 0;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .message-content {
            display: flex;
            flex-direction: column;
            max-width: 70%;

            .message-bubble {
              padding: 8px;
              font-size: 12px;
              line-height: 16px;
              word-wrap: break-word;
            }

            .message-time {
              font-size: 12px;
              color: #999;
            }
          }

          .common-questions {
            background-color: #f8f9fa;
            border-radius: 16px;
            padding: 24px;
            margin-top: 8px;

            .questions-title {
              font-size: 28px;
              color: #212121;
              margin-bottom: 16px;
              font-weight: 500;
            }

            .question-item {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px 0;
              border-bottom: 1px solid #e5e5e5;
              font-size: 28px;
              color: #212121;
              cursor: pointer;

              &:last-child {
                border-bottom: none;
              }

              .arrow {
                color: #999;
                font-size: 24px;
              }

              &:active {
                background-color: #f0f0f0;
              }
            }
          }
        }
        // 解决状态
        .resolved-status {
          display: flex;
          //box-sizing: border-box;
          margin-left: 42px;
          margin-top: 6px;
          .status_img {
            display: block;
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
          .yes {
            cursor: pointer;
            display: flex;
            background: #FFFFFF;
            box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            justify-content: center;
            align-items: center;
            padding: 1px 4px;
            margin-right: 12px;
            .status_txt {
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #296BFF;
              line-height: 16px;
              text-align: left;
              font-style: normal;
            }
          }
          .no {
            cursor: pointer;
            display: flex;
            background: #FFFFFF;
            box-shadow: inset 0px 1px 3px 0px rgba(255,255,255,0.5);
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            justify-content: center;
            align-items: center;
            padding: 1px 4px;
            .status_txt {
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              color: #646772;
              line-height: 16px;
              text-align: left;
              font-style: normal;
            }
          }
          .not {
            display: flex;
            cursor: pointer;
            .status_txt {
              color: #979DAA;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 10px;
              line-height: 16px;
              text-align: left;
              font-style: normal;
            }
          }
        }
      }
      .dialog-content::-webkit-scrollbar {
        /*滚动条整体样式*/
        display: block;
        width : 8px;  /*高宽分别对应横竖滚动条的尺寸*/
      }
      .dialog-content::-webkit-scrollbar-corner{
        display: none;
      }
      .dialog-content::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 4px;
        background: #C9CAD2;
      }
      .dialog-input {
        height: 86px;
        .dialog-btn {
          display: flex;
          .btn {
            transition: all 0.3s;
            cursor: pointer;
            padding: 0 7px;
            height: 23px;
            background: linear-gradient( 180deg, rgba(210,224,255,0.4) 0%, #FFFFFF 100%);
            border-radius: 22px;
            border: 1px solid #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            .weixin {
              display: block;
              width: 14px;
              height: 12px;
            }
            .tousuo {
              display: block;
              width: 15px;
              height: 13.5px;
            }
            .btn-txt {
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 12px;
              color: #030A17;
              line-height: 17px;
              text-align: left;
              font-style: normal;
              margin-left: 4px;
            }
          }
          .btn:first-of-type {
            margin: 0 12px 0 16px;
          }
          .btn:hover {
            background: #FFFFFF;
          }
        }
        .input-container {
          margin-top: 8px;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 0 16px;
          position: relative;
          .message-input {
            flex: 1;
            padding: 10px 12px;
            border-radius: 20px;
            outline: none;
            font-size: 14px;
            box-sizing: border-box;
            padding-right: 45px;
            border: none;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            &:focus {
              //border-color: #1775FF;
            }

            &::placeholder {
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #9499A4;
              line-height: 14px;
              text-align: left;
              font-style: normal;
            }
          }
          .send {
            position: absolute;
            display: block;
            width: 48px;
            height: 48px;
            cursor: pointer;
            top: -1.5px;
            right: 12px;
          }
        }
      }
    }
  }

  // 弹窗动画
  .service-fade-enter-active, .service-fade-leave-active {
    transition: all 0.3s ease;
  }

  .service-fade-enter, .service-fade-leave-to {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/all-btn.vue